import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { Close, Done } from "@material-ui/icons";

export default function OutcomeMenuIcon({ outcome }) {
  const theme = useTheme();
  const Icon = outcome === "won" ? Done : Close;
  const palette = outcome === "won" ? theme.palette.success : theme.palette.error;
  return <Icon style={{ color: theme.palette.type === "dark" ? palette.main : palette.dark, fontSize: 18 }} />;
}
